const styles = {
    paper: {
        padding: '20px',
        paddingTop: '40px',
        paddingBottom: '40px',
        margin: '8px',
        backgroundColor: '#EBF5F7',
        display: 'flex',
        width: '70%',
        '@media only screen and (min-width:250px) and (max-width:550px)': {
            width: '90%',
        },
    },
    filterWrapper: {
        display: 'flex',
        justifyContent: 'flex-end',
        width: '85%',
        '@media only screen and (min-width:250px) and (max-width:550px)': {
            width: '99%',
        },
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        height: 'calc(100vh - 98px)',
    },
    contentWrapper: { height: '100%', overflowY: 'auto' },
    mainLabel: {
        fontWeight: 500,
        fontSize: '1.125rem',
        lineHeight: '1.75rem',
        '@media only screen and (min-width:250px) and (max-width:550px)': {
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
        },
    },
    leftWrapper: {
        display: 'flex',
        flex: 1,
        wordBreak: 'break-word' as 'break-word',
        flexDirection: 'column' as 'column',
    },
    emtyBox: {
        marginTop: '50px',
        display: 'flex',
        flexDirection: 'column' as 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
}

export default styles
